import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import {
  earnings,
  EarningsFilterRequest,
  EarningsFilterResponse,
} from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

import { fetchEntities } from '../use-screener-events/utils';

const QUERY_KEY_EARNINGS_FILTER = 'QUERY_KEY_EARNINGS_FILTER';

export const useEarningsFilter = (
  body: EarningsFilterRequest,
  shouldFetchEntities = true
) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: [QUERY_KEY_EARNINGS_FILTER, body],
    queryFn: async ({ signal }) => {
      const { path, schema } = earnings.postEarningsFilter;
      const earningsFilterResponse =
        await wretchRequest<EarningsFilterResponse>(path, {
          method: 'post',
          body,
          schema,
          signal,
        });
      const { earnings: earningsData } = earningsFilterResponse;

      const entityTags = earningsData.map(earning => earning.entity_tag);

      const entities = await fetchEntities(
        queryClient,
        shouldFetchEntities ? entityTags : []
      );
      const entitiesMap = new Map(entities.map(entity => [entity.tag, entity]));

      return earningsData.map(earning => {
        const entity = entitiesMap.get(earning.entity_tag);
        return entity ? { ...earning, entity } : earning;
      });
    },
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !!body.entities ? body.entities.length > 0 : true,
  });
};
